<template>
  <li :class="{ 'active-trail': active }">
    <router-link
      :class="{
        'sidebar__nav-bigtitle': true,
        'notification-dot': notification,
        'icon-challenges-nav-bar-icon': section.text === 'Modules',
        'icon-couchtraq': section.text === 'Traqing',
        'icon-rewards-nav-bar-icon': section.text === 'Rewards',
        'icon-social-nav-bar-icon': section.text === 'Social',
        'icon-profile-nav-bar-icon': section.text === 'Profile',
        'icon-check': section.text === 'Approve',
      }"
      :to="{
        name: route,
        params: params,
      }"
    >
      <span
        >{{ section.text }}
        <span class="number" v-if="stat">{{ stat }}</span></span
      >
    </router-link>
    <ul class="sidebar__nav-sub">
      <slot></slot>
    </ul>
  </li>
</template>

<script>
export default {
  name: "SideNavSection",
  props: {
    notification: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
    stat: {
      type: Number,
      default: 0,
    },
    section: {
      type: Object,
      required: true,
      validator: (value) => {
        const keys = Object.keys(value);
        return (
          keys.includes("text") &&
          keys.includes("userRoute") &&
          keys.includes("restrictedRoute")
        );
      },
    },
  },
  computed: {
    route() {
      if (this.user.isExpert || this.user.isProvider)
        return this.section.restrictedRoute;
      if (this.user.isTemplate) {
        if (this.section.templateRoute) return this.section.templateRoute;
        return this.section.restrictedRoute;
      }
      return this.section.userRoute;
    },
  },
  data() {
    return {
      params: this.section.text === "Profile" ? { id: this.user.id } : "",
    };
  },
};
</script>

<style scoped></style>
